export { withPortalLocale } from './with-portal-locale';
